import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Ring2.scss';
const Ring2 = ({ size = 40, color = 'black', speed = 0.8, stroke = 5, strokeLength = 0.25, bgOpacity = 0.1, }) => {
    const sizeInt = parseInt(size + '');
    const strokeInt = parseInt(stroke + '');
    const centerPoint = sizeInt / 2;
    const radius = Math.max(0, sizeInt / 2 - strokeInt / 2);
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
            '--uib-dash': String(parseFloat(strokeLength + '') * 100),
            '--uib-gap': String(100 - parseFloat(strokeLength + '') * 100),
            '--uib-bg-opacity': bgOpacity + '',
        }, children: _jsxs("svg", { className: styles.inner, viewBox: `${centerPoint} ${centerPoint} ${size} ${size}`, height: size, width: size, children: [_jsx("circle", { className: styles.track, cx: size, cy: size, r: radius, pathLength: "100", strokeWidth: `${stroke}px`, fill: "none" }), _jsx("circle", { className: styles.car, cx: size, cy: size, r: radius, pathLength: "100", strokeWidth: `${stroke}px`, fill: "none" })] }) }));
};
export default Ring2;
